// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3yHLq","disabled":"FileBtn_disabled__d2_Rc","warn":"FileBtn_warn__YdH7v","fade":"FileBtn_fade__1rwzm"};